import { InventObject } from './InventObject.ts'
import type { InventoryMapObjectData, InventoryMapObjectTypes } from '@/widgets'
import { centerOfMass, lineString } from '@turf/turf'

export default class InventObjectLine extends InventObject {
  constructor(objectData: InventoryMapObjectData, objectType: InventoryMapObjectTypes) {
    super(objectData, objectType)

    this.feature = lineString(objectData.coordinates, this.properties)
    this.geometry = this.feature.geometry
  }

  public transformCoords(coords: any) {
    return coords
  }

  public getLabelCoords(): number[] {
    return centerOfMass(this.feature).geometry.coordinates
  }

  public getTransformCoords(): number[][] {
    return this.feature.geometry.coordinates as any[]
  }

  public getFeatureCoords(): number[] {
    return this.feature.geometry.coordinates as any[]
  }

  public setTransformPointCoords(index: number, coords: []) {
    const pts = [...(this.feature.geometry.coordinates as any[])]
    pts[index] = coords
    this.feature.geometry = { ...this.feature.geometry, coordinates: pts }
  }

  public setTransformPointsCoords(coords: any[]) {
    this.feature.geometry = { ...this.feature.geometry, coordinates: coords }
  }

  public deletePoint(index: number) {
    const pts = [...(this.feature.geometry.coordinates as any[])]
    pts.splice(index, 1)
    this.feature.geometry = { ...this.feature.geometry, coordinates: pts }
  }
}
